import { MobXProviderContext } from 'mobx-react';
import React from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { isSoftUpdateAvailable } from 'Utils/updateVersionGate';

const useShowUpdateAvailableBanner = () => {
  const { ui } = React.useContext<RootStoreProps>(MobXProviderContext);

  // Returns true when the update banner has not been dismissed and a soft
  // update is available.
  const shouldShowUpdateBanner =
    ui.shouldShowUpdateAvailableBanner && isSoftUpdateAvailable();

  return shouldShowUpdateBanner;
};

export default useShowUpdateAvailableBanner;